var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"famousTeaSpecialarea"},[_c('Listbox',{attrs:{"props-titile":_vm.title}},[_c('div',[_c('iframe',{ref:"iframe",staticClass:"iframeBox",attrs:{"src":_vm.iframeSrc,"width":"100%","height":"880"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }